import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { tokenGiris } from '../services/api';

export default function TokenGiris() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [durum, setDurum] = useState('Giriş yapılıyor...');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setDurum('Geçersiz link!');
      return;
    }

    tokenGiris(token)
      .then(res => {
        localStorage.setItem('kullanici', JSON.stringify(res.data));
        localStorage.setItem('giristipi', 'token');
        const { kayitNo, muayeneId, masterProtNo } = res.data;
        // BILDIRIMLER.MASTERPROTNO → mprotno, BILDIRIMLER.MUAYENE_ID → muayeneId
        navigate(`/hasta/${kayitNo}?mprotno=${masterProtNo}&muayeneId=${muayeneId}`, { replace: true });
      })
      .catch(() => {
        setDurum('Geçersiz veya süresi dolmuş link!');
      });
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--med-dark)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 32, textAlign: 'center', maxWidth: 320 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🏥</div>
        <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)' }}>{durum}</div>
        {durum.includes('Geçersiz') && (
          <button className="btn btn-primary" style={{ marginTop: 20, width: '100%' }}
            onClick={() => navigate('/login')}>
            Giriş Sayfasına Git
          </button>
        )}
      </div>
    </div>
  );
}
